import { Button, Chip, MenuItem, TextField } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

import { DataTable, DateText, MoneyText, PageHeader, PermissionGate, StatusChip, useListParams } from "../components";
import help from "./HELP.md?raw";
import { useCustomers, type Customer } from "./useData";

export function Customers() {
  const navigate = useNavigate();
  const [params, setParams] = useListParams({ ordering: "name" });
  const list = useCustomers(params);
  const columns: GridColDef<Customer>[] = [
    { field: "number", headerName: "Number", width: 110 },
    { field: "name", headerName: "Customer", flex: 1, minWidth: 220, renderCell: (p) => <span>{p.value as string}{p.row.credit_hold && <Chip size="small" color="error" label="credit hold" sx={{ ml: 1 }} />}</span> },
    { field: "status", headerName: "Status", width: 110, renderCell: (p) => <StatusChip status={p.value as string} /> },
    { field: "industry", headerName: "Industry", width: 150 },
    { field: "owner_email", headerName: "Owner", width: 200 },
    { field: "territory_code", headerName: "Territory", width: 100 },
    { field: "credit_limit", headerName: "Credit limit", width: 130, renderCell: (p) => <MoneyText amount={p.value as string} currency={p.row.currency} /> },
    { field: "last_activity_at", headerName: "Last activity", width: 130, renderCell: (p) => <DateText value={p.value as string} /> },
  ];
  return (
    <>
      <PageHeader help={help} title="Customers" subtitle="Accounts, prospects and credit" crumbs={[{ label: "CRM" }, { label: "Customers" }]}
        actions={<PermissionGate permission="crm.customer.create"><Button variant="contained" onClick={() => navigate("/app/crm/customers/new")}>New customer</Button></PermissionGate>} />
      <DataTable viewKey="crm.customer.list" columns={columns} data={list.data} isLoading={list.isLoading} params={params} onParamsChange={setParams} exportPath="/api/v1/crm/customers/export/"
        onRowClick={(row) => navigate(`/app/crm/customers/${row.id}`)}
        filters={<>
          <TextField select size="small" label="Status" value={String(params.status ?? "")} onChange={(e) => setParams({ ...params, status: e.target.value, page: 1 })} sx={{ width: 140 }}><MenuItem value="">All</MenuItem>{["prospect", "active", "on_hold", "inactive"].map((s) => <MenuItem key={s} value={s}>{s.replace("_", " ")}</MenuItem>)}</TextField>
          <TextField select size="small" label="Owner" value={String(params.mine ?? "")} onChange={(e) => setParams({ ...params, mine: e.target.value, page: 1 })} sx={{ width: 140 }}><MenuItem value="">Everyone</MenuItem><MenuItem value="1">Mine</MenuItem></TextField>
        </>} />
    </>
  );
}
